import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Landing from "../pages/landing/page";
import Login from "../pages/login/page";
import Signup from "../pages/signup/page";
import Dashboard from "../pages/dashboard/page";
import Flashcards from "../pages/flashcards/page";
import Quiz from "../pages/quiz/page";
import Pricing from "../pages/pricing/page";
import Subscription from "../pages/subscription/page";
import Settings from "../pages/settings/page";
import ForgotPassword from "../pages/forgot-password/page";
import ResetPassword from "../pages/reset-password/page";
import Audio from "../pages/audio/page";
import Stats from "../pages/stats/page";
import Exam from "../pages/exam/page";
import Privacy from "../pages/legal/Privacy";
import Terms from "../pages/legal/Terms";
import Notices from "../pages/legal/Notices";
import Contact from "../pages/legal/Contact";
import StudyGuide from "../pages/study-guide/page";
import HelpCenter from "../pages/help-center/page";
import Changelog from "../pages/changelog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Landing />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/flashcards",
    element: <Flashcards />,
  },
  {
    path: "/quiz",
    element: <Quiz />,
  },
  {
    path: "/audio",
    element: <Audio />,
  },
  {
    path: "/exam",
    element: <Exam />,
  },
  {
    path: "/stats",
    element: <Stats />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/subscription",
    element: <Subscription />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/legal/privacy",
    element: <Privacy />,
  },
  {
    path: "/legal/terms",
    element: <Terms />,
  },
  {
    path: "/legal/notices",
    element: <Notices />,
  },
  {
    path: "/legal/contact",
    element: <Contact />,
  },
  {
    path: "/study-guide",
    element: <StudyGuide />,
  },
  {
    path: "/help-center",
    element: <HelpCenter />,
  },
  {
    path: "/changelog",
    element: <Changelog />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
